module.exports = __webpack_public_path__ + "static/media/ford-auth-hi.27ef4ea0.png";